import moment from "moment";
import { Card, CardBody, CardHeader, Col, Row, Accordion, AccordionItem, AccordionHeader, AccordionBody, } from "reactstrap";
import { useEffect, useState } from "react";
import { LabelText } from "../Utils/Input";
import { useSelector } from "react-redux";
import StatusBadge from "./StatusBadge";

export const DetailedTaskView = ({ taskDetails, configurations,taskPath}) => {
    const [openAccordion, setOpenAccordion] = useState("");
    const toggleAccordion = (open, setOpen, taskEnabledValue, ifbrmTaskEnabledValue) => {
        const toggle = (id) => {
            if (!taskEnabledValue && (id === '1' || id === '2')) {
                return;
            }
            if (!ifbrmTaskEnabledValue && (id === '3' || id === '4')) {
                return;
            }
            if (open === id) {
                setOpen();
            } else {
                setOpen(id);
            }
        };

        return toggle;
    };


    const formatTaskType = (taskType) => {
        return taskType
            .toLowerCase()
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
    let taskEnabledValue, brmTaskEnabledValue;
    const configData = useSelector((state) => state.OperatorSpecificConfig.OperatorSpecificConfiguration)

    configData?.configurations.forEach(config => {
        if (config.name === "TaskManagement") {
            config.value.forEach(item => {
                if (item.key === "TaskEnabled") {
                    taskEnabledValue = item.value[0] === "True" ? true : false;
                } else if (item.key === "BRMTaskEnabled") {
                    brmTaskEnabledValue = item.value[0] === "True" ? true : false;
                }
            });
        }
    });

    useEffect(() => {
        if (brmTaskEnabledValue) {
            setOpenAccordion(false);
        }
    }, [brmTaskEnabledValue]);

    const toggle = toggleAccordion(openAccordion, setOpenAccordion, taskEnabledValue, brmTaskEnabledValue);

    return (
        <div className={taskPath==="tasks"?"p-3 mt-n5":"ms-0"}>

            <h4 className="card-title mb-0 flex-grow-1  mt-4 mb-2">View Task</h4>

            <CardBody>
                <div className="border rounded-1 px-4 py-3 my-2 bg-white h-100">
                    <Row className="gy-4 mb-4 ms-0 d-flex justify-content-between align-items-center">
                        <Col lg={4}>
                            <div className="fw-semibold mb-2">Task Type</div>
                            <div>{formatTaskType(taskDetails?.taskType)}</div>
                        </Col>

                        <Col lg={4} >
                            <div className="fw-semibold mb-2">Task Start Time</div>
                            <div>
                                {moment(taskDetails?.taskTime).format("DD MMM YYYY, HH:mm:ss")}
                            </div>
                        </Col>

                        <Col lg={4} >
                            <div className="fw-semibold mb-2">Task End Time</div>
                            <div>
                                {moment(taskDetails?.endTime).format("DD MMM YYYY, HH:mm:ss")}
                            </div>
                        </Col>
                    </Row></div>

                <Row className=" ">
                    <Col lg={12}>
                        <div className="d-flex align-items-center mt-3 mb-3">
                            <h4 className="me-2 mb-0">Internal</h4>
                            {!taskEnabledValue ? (
                                <span className="text-muted">Not Enabled</span>
                            ) : (
                                <StatusBadge value={taskDetails?.internalStatus} />
                            )}
                        </div>
                        <Accordion className={` ${!taskEnabledValue ? 'global-state-true top-border-radius' : ''}`} open={openAccordion} toggle={toggle}>
                            <AccordionItem>
                                <div className="fw-semibold ms-0 mt-3 mb-1">
                                    <div>
                                        {/* <Row className="d-flex justify-content-between align-items-end">
                                            <Col>
                                                <div className="fw-bold mb-2 mt-0 ms-3">Internal Status</div>
                                                
                                            </Col>
                                        </Row> */}
                                    </div>
                                    {/* <hr className="w-100" /> */}
                                </div>
                                <AccordionHeader targetId="1" className="mb-0 mt-n3 offer-name ">
                                    Request Sent
                                </AccordionHeader>
                                <AccordionBody accordionId="1">
                                    {taskEnabledValue ? <pre className="task-color">
                                        {JSON.stringify(taskDetails?.requestSent, null, 2)}
                                    </pre> : <LabelText displayText={"The configuration is not supported"} />}
                                </AccordionBody>
                            </AccordionItem>
                            <AccordionItem>
                                <AccordionHeader targetId="2" className="mb-0">
                                    Response Received
                                </AccordionHeader>
                                <AccordionBody accordionId="2" >
                                    {taskEnabledValue ?
                                        <pre className="task-color">
                                            {JSON.stringify(taskDetails?.responseReceived, null, 2)}
                                        </pre> : <LabelText displayText={"The configuration is not supported"} />}
                                </AccordionBody>
                            </AccordionItem>
                        </Accordion>
                    </Col>
                    <Col lg={12}>
                        <div className="d-flex align-items-center mt-3 mb-3">
                            <h4 className="me-2 mb-0">External</h4>
                            {!brmTaskEnabledValue ? (
                                <span className="text-muted">Not Enabled</span>
                            ) : (
                                <StatusBadge value={taskDetails?.provisioningStatus} />
                            )}
                        </div>

                        <Accordion className={` ${!brmTaskEnabledValue ? 'global-state-true top-border-radius' : ''}`} open={openAccordion} toggle={toggle}>
                            <AccordionItem>
                                <div className="fw-semibold ms-0 mt-3 mb-1">
                                    <div>
                                        {/* Your commented out code remains the same */}
                                    </div>
                                </div>
                                <AccordionHeader targetId="3" className="mb-0 mt-n3">
                                    Request Sent
                                    <Col>

                                    </Col>
                                </AccordionHeader>
                                <AccordionBody accordionId="3">
                                    {brmTaskEnabledValue ? <pre className="task-color">
                                        {JSON.stringify(taskDetails?.externalTracker?.requestSent, null, 2)}
                                    </pre> : <LabelText displayText={"The configuration is not supported"} />}
                                </AccordionBody>
                            </AccordionItem>
                            <AccordionItem>
                                <AccordionHeader targetId="4" className="mb-0">
                                    Response Received
                                </AccordionHeader>
                                <AccordionBody accordionId="4">
                                    {brmTaskEnabledValue ? <pre className="task-color">
                                        {JSON.stringify(taskDetails?.externalTracker?.responseReceived, null, 2)}
                                    </pre> : <LabelText displayText={"The configuration is not supported"} />}
                                </AccordionBody>
                            </AccordionItem>
                        </Accordion>
                    </Col>
                </Row>
            </CardBody>
        </div>
    );
};
